import { render } from "./Vhtml.vue?vue&type=template&id=2d8e6902"
import script from "./Vhtml.vue?vue&type=script&lang=js"
export * from "./Vhtml.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/craft-fos-scoutsmap/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__